module.exports = __webpack_public_path__ + "52b2e5bc22e50d924f99b4ca1964d2b4.mp3";